import { ERROR_MESSAGE, NOT_FOUND_PAGE } from 'appConstants';
import ErrorMessage from 'components/errorMessage/ErrorMessage';
import Page from 'components/shared/Page';
import { Spinner } from 'components/spinner/Spinner';
import React from 'react';

type Props = {
  status: null | 'notFound' | 'error';
};

/**
 * A lesson page while it loads, or when it is not found or fails to load
 */
const LessonPageStatus: React.FC<Props> = ({ status }) => (
  <Page bypassPageAccess>
    {status === null ? (
      <Spinner />
    ) : (
      <ErrorMessage message={status === 'notFound' ? NOT_FOUND_PAGE : ERROR_MESSAGE} />
    )}
  </Page>
);

export default LessonPageStatus;
